import React from "react";
import CallOverviewSection from "./sections/CallOverviewSection";
import NoQueueAccessNotice from "@/components/common/NoQueueAccessNotice";
import { useAppData } from "@/contexts/AppDataContext";
import { canViewCallQueueInsight } from "@/utils/userUtils";

const QueueTab: React.FC<{ isGeneralMode?: boolean }> = ({ isGeneralMode }) => {
  const { userRole, queuesResponse } = useAppData();
  const canViewCallQueue = canViewCallQueueInsight(userRole, queuesResponse);

  if (!isGeneralMode) return null;

  if (!canViewCallQueue) {
    return <NoQueueAccessNotice />;
  }

  return (
    <div className="w-full">
      <div className="border text-primary bg-[#FCFCFD] rounded-lg dark:border-[#3C5C73] dark:bg-[#3C5C73] dark:text-white px-[8px] pb-[8px] pt-1">
        <CallOverviewSection isGeneralMode={true} />
      </div>
    </div>
  );
};

export default QueueTab;
